import { useNavigate, useLocation } from "react-router-dom";
import { useUnsavedChanges } from "../context/UnsavedChangesContext";

export function useConfirmNavigate() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isDirty, setIsDirty } = useUnsavedChanges();

    function confirmAndNavigate(to, options = {}) {
        if (isDirty) {
            const shouldLeave = window.confirm("You have unsaved changes. Leave?");
            if (!shouldLeave) return;
        }
        setIsDirty(false);

        navigate(to, options);
    }

    return confirmAndNavigate;
}
